/**
 * ProfessocialPost unterscheidet die Templates und stellt alle Module dafür bereit
 */

import React from 'react'

import {
  PostTypeEnum,
  ViewEnum,
  ScreenEnum, PostingTemplate,
} from '@professocial/professocialTypes/types/commonTypes'
import { FacebookPost, LinkedInPage } from '@3m5/sm_publish-frontend-api'

import LinkedInOverview from '../LinkedIn/LinkedInOverview'
import LinkedInPreview from '../LinkedIn/LinkedInPreview'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { EUserRole } from '@professocialApi/professocial-core-frontend-api'
import { LinkedInPost } from '@3m5/sm_publish-frontend-api'

export interface ILinkedInPostProps {
  userRole?: EUserRole
  view?: ViewEnum
  postType?: PostTypeEnum
  size?: ScreenEnum
  networkPageId?: string
  post: LinkedInPost | PostingTemplate | undefined
  networkType?: NetworkType
  page?: LinkedInPage
  onEditFeed?: (post: any) => void
}

const LinkedInPostTemplate: React.FC<ILinkedInPostProps> = (props) => {
  let postType: PostTypeEnum = PostTypeEnum.MESSAGE
  if (props.post?.content.image?.url) postType = PostTypeEnum.PHOTO
  if (props.post?.content.video?.url) postType = PostTypeEnum.VIDEO
  if (props.post?.content.link?.url) postType = PostTypeEnum.LINK

  const showTemplate = () => {
    switch (props.view) {
    case ViewEnum.overview:
      return (
        <LinkedInOverview
          userRole={props.userRole}
          postType={postType}
          view={props.view}
          size={props.size}
          networkPageId={props.networkPageId}
          post={props.post}
          page={props.page}
          networkType={props.networkType}
          onEditFeed={props.onEditFeed}
        />)
    case ViewEnum.preview:
      return (
        <LinkedInPreview
          userRole={props.userRole}
          postType={postType}
          view={props.view}
          size={props.size}
          networkPageId={props.networkPageId}
          post={props.post}
          networkType={props.networkType}
        />)
    }
  }

  return (
    <>
      {showTemplate()}
    </>
  )
}
export default LinkedInPostTemplate
